export default __webpack_public_path__ + "static/media/cash.ce4867fa.svg";